import { BaseService, Service } from "/@/cool";
@Service("weekTaskReject")
class WeekTaskReject extends BaseService {
    constructor() {
        super();

        let prefix = "";
        if (this.namespace) {
            prefix = this.namespace.replace(/\//g, ":") + ":";
        }

        this.permission["repairOrder"] = prefix + "repairOrder";
        this.permission["groupRejectOrder"] = prefix + "groupRejectOrder";
        this.permission["factoryRejectOrder"] = prefix + "factoryRejectOrder";
        this.permission["customerServiceRepairOrder"] = prefix + "customerServiceRepairOrder";
	}
    groupRejectOrder(data: any) {
        return this.request({
            url: "/groupRejectOrder",
            method: "POST",
            data
        });
    }
    factoryRejectOrder(data: any) {
        return this.request({
            url: "/factoryRejectOrder",
            method: "POST",
            data
        });
    }
    customerServiceRepairOrder(data: any) {
        return this.request({
            url: "/customerServiceRepairOrder",
            method: "POST",
            data
        });
    }
    repairOrder(data: any) {
        return this.request({
            url: "/repairOrder",
            method: "POST",
            data
        });
    }

}
export default WeekTaskReject;
